// Cursor pagination helper:
// Backend may return `next` as a full URL (DRF-style) or a raw cursor token.
// We always want to store/send just the cursor token.

export function normalizeCursor(v?: string | null): string | null {
  if (!v || typeof v !== 'string') return null

  // If v is a URL (absolute or relative) that includes `cursor=...`, extract it.
  const m = v.match(/[?&]cursor=([^&#]+)/)
  if (m && m[1]) {
    try {
      return decodeURIComponent(m[1])
    } catch {
      return m[1]
    }
  }

  // Otherwise assume it's already a cursor token.
  return v
}

